import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TransactionChats, formatBalance, formatDate } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useCreateProblemTransactionChatMutation,
  useLazyGetProblemTransactionRecipientClientsOfficiasQuery,
} from '../store/services/customers';

const IncomingTransactionChats = (): React.JSX.Element => {
  const {
    customersProblemTransactions: {
      incoming: { chats, transaction, recipientAccounts },
    },
    customersDictionaries: {
      currentEmployee,
      currenciesList,
      activePermissions,
    },
  } = useAppSelector((state) => state);

  const [createTransactionChat, { isLoading: chatCreateInProgress }] =
    useCreateProblemTransactionChatMutation();

  const { transactionId } = useParams();

  const [getRecipientAccounts] =
    useLazyGetProblemTransactionRecipientClientsOfficiasQuery();

  const onCreateTransactionChat = (userIds?: string[]) => {
    const title = `RFI: Incoming transaction ${formatBalance(
      transaction?.sum || 0,
      currenciesList?.find((item) => item.id === transaction?.currencyId),
    )} ${transaction?.currency?.name} ${
      transaction?.transferDate ? formatDate(transaction?.transferDate) : ''
    }`;

    if (!userIds?.length) {
      createTransactionChat({
        id: transactionId as string,
        body: {
          title,
          employeeId: currentEmployee?.id as string,
          organizationId: transaction?.recipientAccount?.organizationId,
        },
      });
    } else {
      Promise.all(
        userIds.map((item) =>
          createTransactionChat({
            id: transactionId as string,
            body: {
              title,
              employeeId: currentEmployee?.id as string,
              organizationId: transaction?.recipientAccount?.organizationId,
              userId: item,
            },
          }),
        ),
      );
    }
  };

  useEffect(() => {
    if (
      transaction &&
      transaction.recipientAccount &&
      transaction.recipientAccount?.organization?.type === 'CORPORATE' &&
      !recipientAccounts
    ) {
      getRecipientAccounts(transaction.recipientAccount.organizationId);
    }
  }, [transaction, recipientAccounts]);

  return (
    <TransactionChats
      chats={chats}
      companyOfficials={recipientAccounts}
      individualCustomer={transaction?.recipientAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
    />
  );
};

export default IncomingTransactionChats;
